import { HTMLAttributes } from 'react'
import Link from 'next/link'

import SVGIcon from '@/components/base/svg-icon'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type SocialsProps = HTMLAttributes<HTMLDivElement>

const Socials = ({ className, ...props }: SocialsProps) => {
  const { menu } = useStore()

  return (
    <div className={cn('flex space-x-spacing-xs py-spacing-xs', className)} {...props}>
      {menu?.social_menu?.menu.map((item, index) => (
        <div key={`social_menu_${item.id}_${index}`} className="flex">
          <Link
            href={item.url}
            scroll={false}
            target={item.target}
            className="-mx-spacing-2xs p-spacing-2xs"
          >
            <SVGIcon
              symbol={`${item.title.toLowerCase()}-icon`}
              className="size-[1.6rem] fill-current"
            />
          </Link>
        </div>
      ))}
    </div>
  )
}

export default Socials
